import en from './translations/en/translation.json';
import pl from './translations/pl/translation.json';
import no from './translations/no/translation.json';
import es from './translations/es/translation.json';

export const resources = {
	en,
	es,
	no,
	pl,
} as const;
